import { goToToday } from 'owa-calendar-module-commanding';
import { ControlIcons } from 'owa-control-icons';
import { formatMonthDayYear } from 'owa-datetime';
import { DisplayOption, FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import loc, { format } from 'owa-localize';
import { observableToday } from 'owa-observable-datetime';
import {
    goToTodayDateText,
    todayStringLowerCaseText,
} from 'owa-calendar-shared-strings/lib/strings/calendarSurfaceCommandBar.locstring.json';

export function getGoToTodayMenuItem() {
    const goToTodayLabel = format(
        loc(goToTodayDateText),
        '\n' + formatMonthDayYear(observableToday())
    );
    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: loc(todayStringLowerCaseText),
        [FilterableMenuItemArgs.icon]: ControlIcons.GotoToday,
        [FilterableMenuItemArgs.onClick]: goToToday,
        [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
        [FilterableMenuItemArgs.ariaLabel]: goToTodayLabel,
        [FilterableMenuItemArgs.title]: goToTodayLabel,
    });
}
